/** Stroke icons drawn on a 24px grid, as in the design. Data files refer to them by name. */
const PATHS = {
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  arrowUpRight: 'M7 17L17 7M9 7h8v8',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0',
  bug: 'M8 6V4h8v2M6 9h12M7 9v6a5 5 0 0 0 10 0V9M4 13h3M17 13h3M5 19l3-2M19 19l-3-2M12 11v6',
  building: 'M3 21h18M5 21V5h9v16M14 9h5v12M8 9h3M8 13h3',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  check: 'M5 12l5 5 9-10',
  checks: 'M2 12.5l4 4 8-9M10 15.5l1 1 8-9',
  clock: 'M12 7v5l3 2M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
  close: 'M6 6l12 12M18 6L6 18',
  menu: 'M4 7h16M4 12h16M4 17h16',
  message: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  minus: 'M5 12h14',
  paperclip:
    'M21 12l-8.5 8.5a5 5 0 0 1-7-7L14 5a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 8',
  plus: 'M12 5v14M5 12h14',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM21 21l-5-5',
  shield: 'M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6z',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  users:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
}

// Icons that point along the reading direction mirror in right-to-left pages.
const DIRECTIONAL = new Set(['arrowRight', 'arrowUpRight'])

export default function Icon({ name, size = 16, stroke = 2, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`${DIRECTIONAL.has(name) ? 'rtl:-scale-x-100' : ''} ${className}`}
    >
      <path d={PATHS[name]} />
    </svg>
  )
}
